import React, {Component} from "react";

class HistoryResultMobile extends Component {
    render() {
        const {results: {lastResultMobile}} = this.props;

        return <div className="lo5d-last-result">
            <div className="bg-white  pt-1 text-left">
                {
                    lastResultMobile && lastResultMobile.map((result, index) => {
                        const isMargin = index > 2;

                        return <div key={index} className="d-inline-flex lo5d-his-result" style={isMargin ? {marginTop: "1vw"} : {}}>
                            <table
                                className={`w-100 mb-0`}>
                                <tbody>
                                <tr>
                                    <td style={{paddingLeft: "1.5vw"}}>
                                        <div
                                            className="custom-last-draw text-left text-black font-weight-bold">{result.drawLabel}</div>
                                        <div className="font-weight-bold">
                                            {
                                                result.results.map((item, i) => {
                                                    const number = item?.fiveDigits?.split("");
                                                    return <div className="w-100 text-left" key={i}>
                                                    <span
                                                        className={`num-last-result last-result-post post-result-${item?.postCode}`}>{item?.postCode}</span>
                                                        {
                                                            number === undefined ? <span/> : number?.map((num, key) => {
                                                                return <span key={key}
                                                                             className={`num-last-result res-last-result fs-num ${key < 2 ? "result-2d" : "result-3d"}`}>{num}</span>
                                                            })
                                                        }
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    })
                }
            </div>
        </div>
    }
}

export default HistoryResultMobile;